import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { NotesModule, HistoryModule, CalendarModule } from 'modules'
import { Button } from 'components'
import {  AccessOptions } from 'features'
import { FaTimes, FaChevronDown } from 'react-icons/fa'

import * as actionCreators from 'store/actions'
import { pageContext, moduleContext, accessContext } from 'context'

const Wrapper = styled.div`
    height: 100%;
    margin: 0;
    overflow-wrap: break-word;
    z-index:1;
    position: relative;
    overflow: hidden;
    display: flex;
    box-sizing: border-box;

    padding: ${props => props.styles.padding};
    width: ${props => props.styles.width};
    max-height: ${props => props.styles.maxHeight};

    @media (max-width: 1000px){
        width: 100%;
    }
`

const Content = styled.div`
    border-radius: 5px;
    height: ${props => props.styles.height || 'auto'};
    width: inherit;
    position: ${props => props.bodyWidth > 1000 && 'fixed'};
    overflow: clip;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background-color: var(--secondary-color);
    border-radius: 5px;
    padding: 0.5rem;
    box-shadow: ${props => `0px 2px 1px -1px var(--primary-accent2-color),` + 
                        `0px 1px 1px 0px var(--primary-accent2-color), ` +
                        `0px 1px 3px 0px var(--primary-accent2-color)`};
`

const Header = styled.div`
    display: grid;
    grid-template-columns: 2rem 1fr 2rem;
    justify-items: center;
    align-items: center;
    margin-bottom: 0.2rem;
    padding: 0 0.5rem;
`

const Title = styled.div`
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 0.3rem;
    font-weight: bolder;
    font-size: 0.8rem;
    align-items: center;
    justify-content: center;
`

class AccessModule extends Component {
    constructor(props){
        super(props);
        this.widthRef = moduleContext.WIDTHS;
        this.buttonStyle = {
            backgroundColor: 'var(--secondary-color)',
            color: 'var(--secondary-accent-color)',
            margin: 0,
            padding: '0.4rem',
            boxShadowColor: 'transparent'
        }

        this.titleStyle = {
            backgroundColor: 'var(--secondary-color)',
            color: 'var(--text-color)',
            margin: 0,
            padding: '0.4rem'
        }

        this.upcomingStyles = {
            primaryColor: 'var(--secondary-color)',
            secondaryColor: 'var(--primary-color)',
            secondaryColor2: 'var(--primary-accent2-color)',
            padding: '0rem 0rem'
        }
    }

    toggleHandler = (module) => {
        this.props.setAccess(module ? true : !this.props.showAccess, module || this.props.access, {})
    }

    getStyles = () => {
        let props = {
            height: this.props.body && `calc(${window.innerHeight}px - 4.5rem)`,
            width: this.props.access === 'CALENDAR' ? accessContext[this.props.access]['width'][this.props.accessProps['range']] : accessContext[this.props.access]['width'],
            float: false,
            padding: 0,
            maxHeight: 'calc(100vh - 2.5rem)'
        }

        const pageType = this.props.activePageType;
        const pageID = this.props.activePageID;
        const page = this.props.activePageType === pageContext.TYPES.PAGES && this.props.data['pages'][pageID]
        const viewType = page && page['page_view']
        const bodyWidth = this.props.body && this.props.body.clientWidth

        if(pageType === pageContext.TYPES.PAGES){
            // Float for KanbanView
            if(viewType === pageContext.VIEWS.KANBAN_VIEW){
                props['float'] = true
            }
            if(this.props.access === 'Calendar'){
                props['width'] = ['week', 'month'].includes(this.props.accessProps['range']) ? '60rem' : '30rem'
            }

            // Small screen
            if(bodyWidth <= 1000){
                // props['width'] = 'calc(100vw-0.5rem)'
                props['width'] = `calc(${bodyWidth}px) !important`
                props['height'] = 'auto'
                props['float'] = false
                props['maxHeight'] = '80vh'

                // Padding for ListView
                if(viewType === pageContext.VIEWS.LIST_VIEW){
                    props['padding'] = '0' 
                    props['width'] = '100%'
                } else if(viewType === pageContext.VIEWS.KANBAN_VIEW){
                    props['padding'] = '0 2.5rem'
                }
            }
        } else if(pageType === pageContext.TYPES.MODULES){
            if(bodyWidth <= 1000){
                props['padding'] = '1rem 4rem' 
                props['width'] = '100vw'
                props['height'] = 'auto'
                props['float'] = false
                props['maxHeight'] = '80vh'
            } else {
                props['width'] = ['week', 'month'].includes(this.props.accessProps['range']) ? '60rem' : props['width']
            }
        }
        
        return props
    }

    onSelectRange = (range) => {
        console.log(range)
        this.setState({range: range})
    }

    render(){
        const styles = this.getStyles()
        const bodyWidth = this.props.body && this.props.body.clientWidth
        const bodyHeight = window.innerHeight
        const title = 
        <Title>
            {accessContext[this.props.access]['title']}
            <FaChevronDown/>
        </Title>
        const content = 
        <Wrapper styles={styles}>
            <Content id='container' styles={styles} backgroundColor='var(--secondary-color)' bodyWidth={bodyWidth}>
                <Header>
                    <span/>
                    <Button text={title}
                        iconOnly contextMenu={<AccessOptions/>} placement='bottom' styles={this.titleStyle}/>
                    <Button icon={<FaTimes/>} styles={this.buttonStyle} onSelect={() => this.props.setAccess(false, this.props.access, {})}/>
                </Header>
                {this.props.access === moduleContext.MODULES.NOTES ? <NotesModule id={this.props.activePageID} type={pageContext.TYPES.PAGES}/>
                : this.props.access === moduleContext.MODULES.HISTORY ? <HistoryModule/>
                : this.props.access === moduleContext.MODULES.CALENDAR ? <CalendarModule modal styles={this.upcomingStyles} onSelectRange={this.onSelectRange}/>
                : null}
            </Content>
        </Wrapper>

        return (
            <Wrapper styles={styles}>
                <Content styles={styles} backgroundColor='var(--secondary-color)' bodyWidth={bodyWidth}>
                    <Header>
                        <span/>
                        <Button text={title}
                            iconOnly contextMenu={<AccessOptions/>} placement='bottom' styles={this.titleStyle}/>
                        <Button icon={<FaTimes/>} styles={this.buttonStyle} onSelect={() => this.props.setAccess(false, this.props.access, {})}/>
                    </Header>
                    {this.props.access === accessContext['NOTES']['value'] ? <NotesModule id={this.props.activePageID} type={pageContext.TYPES.PAGES}/>
                    : this.props.access === accessContext['HISTORY']['value'] ? <HistoryModule/>
                    : this.props.access === accessContext['CALENDAR']['value'] ? <CalendarModule modal styles={this.upcomingStyles} onSelectRange={this.onSelectRange}/>
                    : null}
                </Content>
            </Wrapper>
        )        
    }
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        uid: state.auth.uid,
        activePageID: state.auth.activePageID,
        activePageType: state.auth.activePageType,
        data: state.db.present.data && state.db.present.data.toJS(),

        window: state.content.window,
        body: state.content.body,

        showAccess: state.content.showAccess,
        access: state.content.access,
        accessProps: state.content.accessProps,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setAccess: (showAccess, module, accessProps) => dispatch(actionCreators.setAccess(showAccess, module, accessProps))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessModule);